import { render } from "./LayoutExternal.vue?vue&type=template&id=ee7d6b6c"
import script from "./LayoutExternal.vue?vue&type=script&lang=js"
export * from "./LayoutExternal.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__